import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import messages from '../../../assets/messages';
import renderLocale from '../../../_shared/helpers/renderLocale';
import filterNavItems from '../../../_shared/helpers/filterNavItems';
import ReducerConstants from '../../../_shared/constants/reducers';
import { TradeState } from '../../../_shared/types/trade';
import useTradeCount from '../../../_shared/hooks/trade/useTradeCount';
import useCurrentTradeContext from '../../../_shared/hooks/trade/useCurrentTradeContext';
import ListPageHeader from '../../../_shared/components/ListPageHeader';
import isOmpPlatform from '../../../_shared/utils/isOmpPlatform';

const TradeListHeader = ({ tradeState }) => {
  const locale = renderLocale();
  const [{ context }, { items }, authLoginResponse] = useSelector(
    state => [
      state?.ui?.nav?.primary,
      state?.ui?.nav?.secondary,
      state[ReducerConstants.AUTH]
    ],
    shallowEqual
  );
  const secondaryItems = items[context] || [];
  const filteredItems = filterNavItems(secondaryItems, authLoginResponse);
  const { pathname } = window.location;
  const tradeContext = useCurrentTradeContext();
  const [totalNumberOfTrades, setTotalNumberOfTrades] = useState(0);
  const totalTradeStateCount = useTradeCount(tradeContext);
  const heading = filteredItems.find(item => item.linkTo === pathname);
  const localizedHeading = locale.includes('fr')
    ? heading?.labelFr
    : heading?.label;

  useEffect(() => {
    if (totalTradeStateCount) {
      const tsCount = totalTradeStateCount.find(tradeStateCount => {
        return tradeStateCount.tradeState === tradeState
          ? tradeStateCount.count
          : 0;
      });
      setTotalNumberOfTrades(tsCount?.count || 0);
    }
  }, [totalTradeStateCount, tradeState]);

  const getTradeStateCaption = state => {
    switch (state) {
      case TradeState.upcoming:
        return messages[locale]['list.header.buy.upcoming'];
      case TradeState.active:
        return messages[locale]['list.header.buy.active'];
      case TradeState.pending:
        return isOmpPlatform() ? messages[locale]['list.header.pending'] : '';
      default:
        return '';
    }
  };

  return (
    <ListPageHeader
      mainHeading={localizedHeading}
      subHeading={`${totalNumberOfTrades} ${messages[locale]['list.header.vehicles']}`}
      caption={getTradeStateCaption(tradeState)}
    />
  );
};

export default TradeListHeader;
